import { useApi } from '@/api'

export const useBrandExtractionsResource = () => {
  const api = useApi()
  const brandOf = (organizationId: string, brandId: string) => api.api.v1.organizations({ organizationId }).brands({ brandId })
  const reviewOf = (organizationId: string, brandId: string, extractionId: string) =>
    brandOf(organizationId, brandId).extractions({ extractionId }).review

  return {
    getBrandExtractions: (organizationId: string, brandId: string) => brandOf(organizationId, brandId).extractions.get(),
    setBrandExtraction: (organizationId: string, brandId: string, sourceUrl: string) =>
      brandOf(organizationId, brandId).extractions.post({ sourceUrl }),
    setBrandExtractionReview: (
      organizationId: string,
      brandId: string,
      extractionId: string,
      body: Parameters<ReturnType<typeof reviewOf>['post']>[0]
    ) => reviewOf(organizationId, brandId, extractionId).post(body)
  }
}
